import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

/** Wraps the Iconify web component. Centralizes the custom-element usage. */
@Component({
  selector: 'app-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `<iconify-icon
      [attr.icon]="name"
      [style.font-size.px]="size"
      [style.color]="color || 'inherit'"
      style="line-height:0;display:inline-flex"
    ></iconify-icon>`,
})
export class IconComponent {
  @Input() name!: string;
  @Input() size = 20;
  @Input() color?: string;
}
